module.exports = __webpack_public_path__ + "static/mfg-account_login-min-1.3a8fa4b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/account-login/mfg-account_login-min-1.png
// module id = 14
// module chunks = 10495410396556 212839066777427 230539012308250